import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiVianenRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="Vianen"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={60.00}
      distance="48 km"
      duration="40-45 minuten"
    />
  );
}
